import PropTypes from "prop-types";
import { Button } from "antd";
import { KeyOutlined } from "@ant-design/icons";
import { useHistory } from "react-router-dom";
import DocumentRowIcon from "../documents/DocumentRowIcon";

const StartReservationBanner = ({ resDetails, t }) => {
    const history = useHistory();

    const handleStartReservation = () => {
        if (!resDetails?.id) return;
        history.push(`/reservations/${resDetails.id}/check-in`);
    };

    return (
        <div className="flex flex-col gap-4 rounded-2xl border border-[#f0f0f0] bg-white p-4 shadow-sm lg:flex-row lg:items-center lg:justify-between lg:gap-6 lg:p-5">
            <div className="flex min-w-0 items-start gap-4">
                <DocumentRowIcon icon={<KeyOutlined className="text-lg" />} tone="primary" />
                <div className="min-w-0">
                    <h2 className="fontSemi text-base leading-snug text-[#2F2F46]">
                        {t("upcomingDetails.startBannerTitle")}
                    </h2>
                    <p className="fontRegular mt-1 max-w-2xl text-sm leading-6 text-[#7f8c8d]">
                        {t("upcomingDetails.startBannerDescription")}
                    </p>
                </div>
            </div>
            <Button
                type="primary"
                onClick={handleStartReservation}
                className="!h-11 w-full shrink-0 !rounded-lg !px-6 !text-sm !font-semibold !shadow-none lg:w-auto lg:min-w-[170px]">
                {t("startReservation")}
            </Button>
        </div>
    );
};

StartReservationBanner.propTypes = {
    resDetails: PropTypes.object,
    t: PropTypes.func.isRequired,
};

export default StartReservationBanner;
